import React from "react";

export const SungkaHistory = () => {
  return (
    <div>
      <h1>SITE UNDER DEVELOPMENT</h1>
    </div>
  );
};
